// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"InActivity_maxWidth__37GJB"};